module.exports = __webpack_public_path__ + "static/img/li_1.f0d3240.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/li_1.jpeg
// module id = HjG1
// module chunks = 6